import styled from 'styled-components'

export default styled.div`
    flex: 1;
    opacity: 0;

    &:last-child {
        margin-right: 0;
    }

    *:hover > * > & {
        opacity: 1;
    }
`
